import React, { useContext, useRef } from "react";
import ReactDOM from "react-dom";
import useDropdownMenu from "react-accessible-dropdown-menu-hook";
import { NavLink, Link } from "react-router-dom";
import more from "../../assets/images/icons8-menu-vertical-30.png";
import WithAuthentication from "Authentication/AuthenticationContext.ts";
import "./head.scss";
const items = [
  { name: "صفحه اصلی", to: "/", exact: true },
  { name: "  سوالات متداول", to: "/business" },
  { name: " بلاگ", to: "/profile" },
  { name: "تماس با ما", to: "/about-us" },
];

export default function HeaderTest() {
  const collapseRef = useRef(null);
  const auth = useContext(WithAuthentication);
  const hideBars = () => {
    collapseRef.current.setAttribute("class", "navbar-collapse collapse");
  };
  window.onscroll = () => {
    if (
      !document
        .querySelector(".header-container .navbar-toggler")
        .classList.contains("collapsed")
    ) {
      document
        .querySelector(".header-container .navbar-toggler")
        .classList.add("collapsed");
      document
        .querySelector(".header-container .navbar-collapse")
        .classList.remove("show");
    }
  };
  const { buttonProps, itemProps, isOpen } = useDropdownMenu(5);
  return (
    <>
      <div className="sticky-top header-container" style={{ height: 70 }}>
        <nav
          className="navbar navbar-expand-md navbar-light  "
          style={{
            fontSize: "17px",
            backgroundColor: "#fff",
            padding: "0.5rem 0px",
          }}
        >
          <div
            className="container-fluid header-item-container"
            style={{ maxWidth: "100% !important", width: "100p%" }}
          >
            <div className="d-flex">
              <button
                className="navbar-toggler me-1"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbar"
                aria-controls="navbar"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon" />
              </button>
              <div>
                <Link to="/">
                  <img className="logo" src={"h"} alt="" />
                </Link>
              </div>
            </div>

            {/* حالت موبایل */}
            <div className="d-flex d-md-none mobile-menu-container">
              {auth.isLogged ? (
                <div
                  className="dropdown Mdrop d-md-dropstart"
                  style={{
                    float: "left",
                  }}
                >
                  <button
                    className="btn btn-secondary dropdown-toggle"
                    type="button"
                    id="dropdownMenuButton1"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <img src={more} alt="more" />
                  </button>
                  <ul
                    className="dropdown-menu "
                    aria-labelledby="dropdownMenuButton1"
                  >
                    <li>
                      <Link className="dropdown-item" to={"/user-profile"}>
                        پروفایل کاربر
                      </Link>
                    </li>
                    {auth.userInfo.shopIds.map((value) => {
                      return (
                        <li>
                          <Link
                            className="dropdown-item"
                            to={`/profile/${value.shopSuffix}`}
                          >
                            {value.title}
                          </Link>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              ) : (
                ""
              )}
            </div>

            <div
              className="collapse navbar-collapse "
              id="navbar"
              ref={collapseRef}
            >
              <ul className="navbar-nav ms-0 align-items-center">
                {items.map((item) => {
                  return (
                    <li class="nav-item p-3 text-light ">
                      <NavLink
                        onClick={hideBars}
                        to={item.to}
                        data-toggle="collapse"
                        data-target="#navbarCollapse"
                        className={(navData) =>
                          navData.isActive ? "activeLink" : "nav-link "
                        }
                        exact={item.exact || false}
                      >
                        {item.name}
                      </NavLink>
                    </li>
                  );
                })}
              </ul>
              {/* حالت دسکتاپ */}
              <div className="d-none d-md-block ms-auto">
                {auth.isLogged ? (
                  <div
                    className="dropdown Mdrop d-md-dropstart"
                    style={{ float: "left" }}
                  >
                    <button
                      className="btn btn-secondary dropdown-toggle"
                      type="button"
                      id="dropdownMenuButton1"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <img src={more} alt="more" />
                    </button>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="dropdownMenuButton1"
                    >
                      <li>
                        <Link className="dropdown-item" to={"/user-profile"}>
                          پروفایل کاربر
                        </Link>
                      </li>
                      {auth.userInfo.shopIds.map((value) => {
                        return (
                          <li>
                            <Link
                              className="dropdown-item"
                              to={`/profile/${value.shopSuffix}`}
                            >
                              {value.title}
                            </Link>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </nav>
      </div>
    </>
  );
}
